export default __webpack_public_path__ + "static/media/wx_share.4328d02a.png";